<template>
  <BaseSidebarDrawer v-model="localModelValue" width="408" overlay rounded-left>
    <div class="w-full h-full relative">
      <div class="flex items-center justify-between sticky top-0 !text-blue-dark-500 bg-white border-b px-5 py-[18px] md:!p-6">
        <div class="flex items-center gap-3">
          <BaseIcon icon="support-agent" />
          <span class="font-bold text-sm">کار با سیمان آنلاین</span>
        </div>
        <BaseIcon icon="close" class="cursor-pointer" @click="localModelValue = false" />
      </div>
      <div class="h-[calc(100%_-_162px)] flex flex-col gap-6 overflow-y-auto no-scrollbar overscroll-none py-8 px-5 md:px-6">
        <div
          class="flex items-center justify-between text-blue-dark-500 p-3 rounded-lg border-[1px] border-gray-100 cursor-pointer"
          @click="manageAccounts = true"
        >
          <div class="flex items-center gap-3">
            <BaseIcon icon="tips-and-updates" />
            <span class="text-xs">مدیریت حساب‌های کاربری</span>
          </div>
          <BaseIcon icon="arrow-drop-up" class="-rotate-90" />
        </div>
        <div
          class="flex items-center justify-between text-blue-dark-500 p-3 rounded-lg border-[1px] border-gray-100 cursor-pointer"
          @click="accessToInvoice = true"
        >
          <div class="flex items-center gap-3">
            <BaseIcon icon="tips-and-updates" />
            <span class="text-xs">دسترسی به صورتحساب</span>
          </div>
          <BaseIcon icon="arrow-drop-up" class="-rotate-90" />
        </div>
        <div
          class="flex items-center justify-between text-blue-dark-500 p-3 rounded-lg border-[1px] border-gray-100 cursor-pointer"
          @click="differenceBetweenOrderAndLoad = true"
        >
          <div class="flex items-center gap-3">
            <BaseIcon icon="tips-and-updates" />
            <span class="text-xs">تفاوت سفارش و بار</span>
          </div>
          <BaseIcon icon="arrow-drop-up" class="-rotate-90" />
        </div>
        <div
          class="flex items-center justify-between text-blue-dark-500 p-3 rounded-lg border-[1px] border-gray-100 cursor-pointer"
          @click="statusOfBarDeclaration = true"
        >
          <div class="flex items-center gap-3">
            <BaseIcon icon="tips-and-updates" />
            <span class="text-xs">پیگیری وضعیت اعلام بار</span>
          </div>
          <BaseIcon icon="arrow-drop-up" class="-rotate-90" />
        </div>
      </div>
      <div class="w-full absolute bottom-0 left-0 flex items-center justify-between py-3 px-5 border-t">
        <div class="flex items-center gap-4">
          <BaseIcon icon="support-agent" class="!text-[32px] text-green-600" />
          <div>
            <span class="text-sm text-blue-dark-500">پشتیبانی تلفنی فعال است</span>
            <div class="flex items-center gap-3 text-xs text-blue-dark-200 mt-1">
              <span>09120709974</span>
              <div class="w-px h-3 border-r-[1px] border-blue-dark-200"></div>
              <span>02191300630</span>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-5">
          <BaseIcon icon="copy" class="text-primary-900 cursor-pointer" />
          <a :href="`tel:09120709974`" class="flex">
            <BaseIcon icon="call" class="text-green-600" />
          </a>
        </div>
      </div>
    </div>
  </BaseSidebarDrawer>
  <BaseSidebarDrawer v-model="manageAccounts" width="408" overlay rounded-left>
    <div class="w-full h-full relative">
      <div class="flex items-center gap-3 sticky top-0 !text-blue-dark-500 bg-white border-b px-5 py-[18px] md:!p-6">
        <BaseIcon icon="arrow-forward" class="cursor-pointer" @click="manageAccounts = false" />
        <span class="font-bold text-sm">مدیریت حساب‌های کاربری</span>
      </div>
      <div class="h-[calc(100%_-_162px)] flex flex-col gap-6 overflow-y-auto no-scrollbar overscroll-none py-8 px-5 md:px-6">
        <div
          class="flex items-center justify-between text-blue-dark-500 p-3 rounded-lg border-[1px] border-gray-100 cursor-pointer"
          @click="showAccounts = true"
        >
          <div class="flex items-center gap-3">
            <BaseIcon icon="tips-and-updates" />
            <span class="text-xs">مشاهده حساب کاربری</span>
          </div>
          <BaseIcon icon="arrow-drop-up" class="-rotate-90" />
        </div>
        <div
          class="flex items-center justify-between text-blue-dark-500 p-3 rounded-lg border-[1px] border-gray-100 cursor-pointer"
          @click="switchBetweenAccounts = true"
        >
          <div class="flex items-center gap-3">
            <BaseIcon icon="tips-and-updates" />
            <span class="text-xs">جا‌به‌جایی بین حساب‌های کاربری</span>
          </div>
          <BaseIcon icon="arrow-drop-up" class="-rotate-90" />
        </div>
      </div>
    </div>
  </BaseSidebarDrawer>
  <BaseSidebarDrawer v-model="differenceBetweenOrderAndLoad" width="408" overlay rounded-left>
    <div class="w-full h-full relative">
      <div class="flex items-center gap-3 sticky top-0 !text-blue-dark-500 bg-white border-b px-5 py-[18px] md:!p-6">
        <BaseIcon icon="arrow-forward" class="cursor-pointer" @click="differenceBetweenOrderAndLoad = false" />
        <span class="font-bold text-sm">تفاوت سفارش و بار</span>
      </div>
      <div class="h-[calc(100%_-_162px)] flex flex-col gap-6 overflow-y-auto no-scrollbar overscroll-none py-8 px-5 md:px-6">
        <p class="text-xs text-blue-dark-500 leading-5">
          خرید شما به‌عنوان یک «سفارش» ثبت می‌شود و هر «بار» بخشی از آن محسوب می‌شود. به‌عنوان مثال، اگر ۴۸ تن خرید کرده‌اید، این سفارش ممکن است در دو
          بار جداگانه و با دو ماشین مختلف ارسال شود.
        </p>
      </div>
    </div>
  </BaseSidebarDrawer>
  <BaseSidebarDrawer v-model="statusOfBarDeclaration" width="408" overlay rounded-left>
    <div class="w-full h-full relative">
      <div class="flex items-center gap-3 sticky top-0 !text-blue-dark-500 bg-white border-b px-5 py-[18px] md:!p-6">
        <BaseIcon icon="arrow-forward" class="cursor-pointer" @click="statusOfBarDeclaration = false" />
        <span class="font-bold text-sm">پیگیری وضعیت اعلام بار</span>
      </div>
      <div class="overflow-y-auto no-scrollbar overscroll-none md:py-8 md:px-6">
        <template v-if="!smAndDown">
          <p class="text-xs text-blue-dark-500 leading-5">از نوار کناری گزینه «سفارش‌ها» را انتخاب کنید تا وضعیت سفارش‌های خود را مشاهده کنید.</p>
          <img src="~@/assets/images/support/bar-declaration-status-1.webp" class="w-full h-[206px] object-contain mt-4" />
          <img src="~@/assets/images/support/bar-declaration-status-2.webp" class="w-full h-[206px] object-contain mt-3" />
        </template>
        <template v-else>
          <div class="pt-6 pb-8 px-5 md:px-6 border-b">
            <div class="flex items-center gap-2.5 text-blue-dark-500">
              <div class="w-6 h-6 grid place-items-center text-sm rounded bg-blue-dark-50">1</div>
              <span class="text-xs">ابتدا از نوار پایین، گزینه سفارش را انتخاب کنید.</span>
            </div>
            <img src="~@/assets/images/support/mobile-bar-declaration-status-1.webp" class="w-full h-[245px] object-cover border rounded-lg mt-4" />
          </div>
          <div class="pt-6 pb-8 px-5 md:px-6 border-b">
            <div class="flex gap-2.5 text-blue-dark-500">
              <div class="w-6 h-6 flex-shrink-0 grid place-items-center text-sm rounded bg-blue-dark-50">2</div>
              <span class="text-xs leading-5">
                در این بخش، می‌توانید لیست سفارش‌های خود را در وضعیت‌های مختلف مشاهده کنید. همچنین در صورت نیاز، می‌توانید با استفاده از فیلترهای
                متنوع، جستجوی دقیق‌تری انجام دهید.
              </span>
            </div>
            <img src="~@/assets/images/support/mobile-bar-declaration-status-2.webp" class="w-full h-[245px] object-cover border rounded-lg mt-4" />
            <img src="~@/assets/images/support/mobile-bar-declaration-status-3.webp" class="w-full h-[245px] object-cover border rounded-lg mt-4" />
          </div>
        </template>
      </div>
    </div>
  </BaseSidebarDrawer>
  <ShowAccountsModal v-model="showAccounts" />
  <SwitchBetweenAccountsModal v-model="switchBetweenAccounts" />
  <AccessToInvoice v-model="accessToInvoice" />
</template>

<script setup lang="ts">
import BaseSidebarDrawer from "@/components/base/BaseSidebarDrawer.vue";
import { computed, ref } from "vue";
import ShowAccountsModal from "./ShowAccountsModal.vue";
import SwitchBetweenAccountsModal from "./SwitchBetweenAccountsModal.vue";
import AccessToInvoice from "./AccessToInvoice.vue";
import { useDisplay } from "vuetify";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const { smAndDown } = useDisplay();

const emit = defineEmits(["update:modelValue"]);

const localModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const manageAccounts = ref(false);
const showAccounts = ref(false);
const switchBetweenAccounts = ref(false);
const accessToInvoice = ref(false);
const differenceBetweenOrderAndLoad = ref(false);
const statusOfBarDeclaration = ref(false);
</script>

<style scoped></style>
